import { useRef, useState } from "react";
import axios from "axios";
import { openExternalBrowser } from "@/lib/externalBrowser";

export default function CashbackHotsiteLink({ onNeedsCpf }) {
  const lock = useRef(false);
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState("");
  const open = async () => {
    if (lock.current) return;
    lock.current = true; setOpening(true); setError("");
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/alloyal/cashback/hotsite`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem("auth_token")}` }, timeout: 45000 });
      if (data.needs_cpf) { onNeedsCpf?.(); return; }
      const url = new URL(data.web_smart_link);
      if (url.protocol !== "https:" || url.username || url.password) throw new Error("Invalid link");
      await openExternalBrowser(url.href);
    } catch { setError("Não foi possível abrir o hotsite agora. Tente novamente."); }
    finally { lock.current = false; setOpening(false); }
  };
  return <div className="text-sm text-zinc-400">
    <span>Problemas para carregar? </span>
    <button type="button" disabled={opening} onClick={open} className="rounded cashback-accent-text underline underline-offset-4 hover:cashback-accent-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 disabled:opacity-50">{opening ? "Abrindo hotsite…" : "Acesse o hotsite da plataforma de Cashback"}</button>
    {error && <p role="alert" className="mt-2 text-amber-300">{error}</p>}
  </div>;
}
